module.exports = dormakaba.vendorTerrific['vendor/jquery'];